export const ENV = {
  cac1: {
    DEV: {
      orgName: "DEV",
      id: "4ad137fb-84f9-465d-8a1b-dfaf43af4d1c",
      clientId: "22ae9b5f-6b93-4532-8845-fef485fa29d3",
      name: "maximuscanada-dev",
    },
    ODB: {
      orgName: "ODB",
      clientId: "d75a5598-a2cd-4b49-99ac-ebd22f53ae02",
    },
    SBC: {
      orgName: "SBC",
      clientId: "45035972-50ec-47e7-a80b-8285cdc4d4ca",
    },
    ICC: {
      orgName: "ICC",
      clientId: "a59ae7de-790d-402a-b3ec-e97ea5367e79",
    },
    SDO: {
      orgName: "SDO",
      clientId: "727dbb07-ee5f-45ae-befc-25b629c800be",
    },
    FEC: {
      orgName: "FEC",
      clientId: "620a3ea6-6d47-4964-9e6c-6627c1352b37",
      id: "1628e055-df66-40bf-864f-9ca9a013055a"
    },
    TIM: {
      orgName: "TIM",
      clientId: "46ba9575-94d4-4b8d-b8bc-2da54f38e73d",
    }
  },
  redirect: 'https://blue-sea-0b965d90f.4.azurestaticapps.net',
    // redirect: "http://localhost:3000/",
};